<template>
  <div class="main">
    <heads></heads>
    <navs></navs>
    <banners></banners>
    <div class="content">
      <div class="con-main">
        <div class="con-main-nav">
          <div class="con-main-navs">
            <div class="con-main-navs-title">
              <span class="con-main-navs-title-wz">活动专区</span>
              <span class="con-main-navs-title-en">EVENT AREA</span>
            </div>
            <div class="con-main-navs-st">
              <div :class="zxhdclass" @click="clickhdzq">
                <div class="con-main-navs-st-list-wz">· 最新活动</div>
                <div class="con-main-navs-st-list-en">EVENTS</div>
              </div>
              <div :class="yjdtclass" @click="clickyjdt">
                <div class="con-main-navs-st-list-wz">· 研究动态</div>
                <div class="con-main-navs-st-list-en">STUDY</div>
              </div>
              <div :class="sjdtclass" @click="clicksjdt">
                <div class="con-main-navs-st-list-wz">· 实践动态</div>
                <div class="con-main-navs-st-list-en">PRACTICE</div>
              </div>
            </div>
          </div>
        </div>
        <div class="con-main-nr">
          <div class="con-main-nr-title">
            <div class="con-main-nr-title-bt">
              {{
                ntype == 1 ? "研究动态" : ntype == 2 ? "实践动态" : "最新活动"
              }}
            </div>
            <div class="con-main-nr-title-nav">
              <router-link :to="{ path: '/', query: { idx: 0 } }"
                >首页</router-link
              >
              >
              <router-link :to="{ path: '/hdzq/list' }">活动专区</router-link> >
              {{
                ntype == 1 ? "研究动态" : ntype == 2 ? "实践动态" : "最新活动"
              }}
            </div>
          </div>
          <div class="con-main-nr-ul">
            <div
              class="con-main-nr-li"
              v-for="(item, key) in newslist"
              :key="key"
            >
              <div class="con-main-nr-li-img">
                <el-image
                  style="width: 250px; height: 160px"
                  :src="`${proxy.$imgurl}${
                    item.ThumbImage ? item.ThumbImage[0] : ''
                  }`"
                ></el-image>
              </div>
              <div class="con-main-nr-li-nr">
                <div class="con-main-nr-li-nr-title">
                  {{ item.NewsTitle }}
                </div>
                <div class="con-main-nr-li-nr-con">
                  {{ item.NewsZy }}
                </div>
                <div class="con-main-nr-li-nr-dbxx">
                  <el-button
                    type="primary"
                    size="small"
                    @click="ckgd(item.NewsType, item.Id)"
                    >{{(ntype==4 && item.Id=='728664335328481280') || (ntype==4 && item.Id=='728665619548868608')?'参与活动':'查看更多+'}}</el-button
                  >
                  <div class="con-main-nr-li-nr-dbxx-time">
                    {{ item.NewsDate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="con-main-nr-fy">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              @current-change="fenye"
            />
          </div>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<style scoped>
::v-deep .el-carousel__container {
  height: 200px;
}
a:link,
a:visited {
  text-decoration: none;
  color: #333;
}
a:hover {
  color: #777;
}
.content {
  margin-top: 30px;
}
.main {
  background: #fff;
}
.con-main {
  width: 1200px;
  margin: auto;
  margin-bottom: 30px;
}
.con-main:after {
  content: "";
  display: table;
  clear: both;
}
.con-main-nav {
  float: left;
  width: 270px;
  height: auto;
}
.con-main-nr {
  float: right;
  width: 900px;
  height: auto;
}
.con-main-navs {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
}
.con-main-navs-title {
  width: 100%;
  height: 80px;
  background-image: url("../../assets/img/hdzq/nav.jpg");
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.con-main-navs-st-list {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #ccc;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.con-main-navs-st-list:hover {
  background: #fafafa;
}
.con-main-navs-title-wz {
  font-weight: bold;
  font-size: 20px;
}
.con-main-navs-title-en {
  font-size: 14px;
  padding-top: 5px;
}
.con-main-navs-st-list-wz {
  width: 100px;
  display: block;
}
.con-main-navs-st-list-en {
  width: 100px;
  display: block;
  font-size: 12px;
  padding-left: 25px;
  padding-top: 5px;
}
.con-main-navs-st-list-active {
  color: #296fab;
  cursor: default;
}
.con-main-nr-title {
  width: 100%;
  height: 60px;
  border-bottom: 3px double #333;
}
.con-main-nr-title-bt {
  float: left;
  height: 60px;
  line-height: 60px;
  font-weight: bold;
  font-size: 20px;
}
.con-main-nr-title-nav {
  float: right;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
}
.con-main-nr-ul {
  padding: 10px 0;
}
.con-main-nr-li {
  padding: 20px 0;
  border-bottom: 1px dashed #ccc;
}
.con-main-nr-li:hover {
  background: #fafafa;
}
.con-main-nr-li::after {
  content: "";
  display: table;
  clear: both;
}
.con-main-nr-li-img {
  width: 250px;
  height: 160px;
  float: left;
}
.con-main-nr-li-nr {
  width: 620px;
  height: 160px;
  float: right;
  box-sizing: border-box;
  padding: 10px 0;
}
.con-main-nr-li-nr-title {
  font-weight: bold;
  height: 30px;
  text-overflow: ellipsis; /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap; /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden; /*超出部分隐藏*/
}
.con-main-nr-li-nr-con {
  height: 72px;
  font-size: 14px;
  text-align: justify;
  text-indent: 28px;
  line-height: 24px;
  overflow: hidden;
  margin-bottom: 8px;
}
.con-main-nr-li-nr-dbxx {
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.con-main-nr-li-nr-dbxx-time {
  font-size: 14px;
  color: #999;
}
.con-main-nr-fy {
  padding: 20px 0;
}
</style>

<script setup>
import { get } from "@/utils/index";
// router
import { useRouter } from "vue-router";
const router = useRouter();
import { ref, reactive, getCurrentInstance } from "vue";
const { proxy } = getCurrentInstance();

// 分页
let psize = ref(10);
let pindex = ref(1);
let total = ref(0);
let ntype = ref(4); //1研究动态   2实践动态   3图片新闻  4最新活动
let yjdtclass = ref("con-main-navs-st-list");
let sjdtclass = ref("con-main-navs-st-list");
let zxhdclass = ref("con-main-navs-st-list con-main-navs-st-list-active");
// 新闻列表
let newslist = reactive([]);

// 获取详情
const getdetail = () => {
  get("/api/NewsPaper/GetNewsList", {
    NewsType: ntype.value,
    PageIndex: pindex.value,
    PageSize: psize.value,
    Sort:'NewsSort',
  }).then((res) => {
    // console.log(res);
    newslist.length = 0;
    newslist.push(...res.Data);
    newslist.map((e) => {
      if (e.ThumbImage && e.ThumbImage != "") {
        e.ThumbImage = e.ThumbImage.split(";");
      }
    });
    // console.log(newslist)
    total.value = res.Total;
  });
};
getdetail();

// 分页
const fenye = (value) => {
  pindex.value = value;
  getdetail();
};

// 查看详情
const ckgd = (type, id) => {
  // 非活动的时候跳转详情
  if (type != 4) {
    router.push({
      path: "/hdzq/detail",
      query: {
        id: id,
      },
    });
    // 跳转活动专题页 /hdzq/newhd
  } else {
    // 重庆市健康科普成果展示活动
    if (id == "728664335328481280") {
      router.push({
        path: "/hdzq/newhdzshd",
        query: {
          id: id,
        },
      });
     // 重庆市健康科普大讲堂进校园活动方案
    } else if (id == "728665619548868608") {
      router.push({
        path: "/hdzq/gydjt",
        query: {
          id: id,
        },
      });
    }else{
      router.push({
      path: "/hdzq/detail",
      query: {
        id: id,
      },
    });
    }
  }
};

// 切换研究动态
const clickyjdt = () => {
  ntype.value = 1;
  yjdtclass.value = "con-main-navs-st-list con-main-navs-st-list-active";
  sjdtclass.value = "con-main-navs-st-list";
  zxhdclass.value = "con-main-navs-st-list";
  getdetail();
};
// 切换实践动态
const clicksjdt = () => {
  ntype.value = 2;
  yjdtclass.value = "con-main-navs-st-list";
  sjdtclass.value = "con-main-navs-st-list con-main-navs-st-list-active";
  zxhdclass.value = "con-main-navs-st-list";
  getdetail();
};
// 切换实践动态
const clickhdzq = () => {
  ntype.value = 4;
  yjdtclass.value = "con-main-navs-st-list";
  zxhdclass.value = "con-main-navs-st-list con-main-navs-st-list-active";
  getdetail();
};
</script>
